<template src="./Add.html"></template>

<script>
// import { showAlert } from "@/utils/helpers";

export default {
  created() {

  },
  computed: {
  },
  data() {
    return {
      patient: {
        firstName: null,
        lastName: null,
        email: null,
        phone: null,
        date: null,
      },
    };
  },
  methods: {
    confirm() {
      this.$store
        .dispatch("patients/edit", { id: this.itemId, payload: this.patient })
        .then(() => {
          this.back();
        })
        .catch(() => { });
    },
    allowedDates(val) {
      const today = new Date();
      today.setFullYear(today.getFullYear() - 2);
      const date = new Date(val);
      return date < today;
    },
    back() {
      this.$emit("back");
    },
  },
};
</script>